import { type ActionItem } from 'shared/ui'
import { type RowUser } from 'entities/Users/model/Table/RowUser'
import { type IEntitiesStore } from 'entities/EntitiesExport'
import { DeleteMemberStore } from 'pages/settings/pages/members/ui/actions/deleteMember/ui'

export const deleteMemberAction = (
  member: RowUser,
  entities: IEntitiesStore,
  onSuccess?: () => void | Promise<void>
) => {
  const onDelete = () => new DeleteMemberStore(member, entities, onSuccess)

  return onDelete()
}

export const deleteMember = (
  member: RowUser,
  entities: IEntitiesStore,
  onSuccess?: () => void | Promise<void>
): ActionItem => {
  return {
    text: 'Delete member',
    icon: 'delete',
    onAction: () => {
      deleteMemberAction(member, entities, onSuccess)
    },
  }
}
